import { useState } from 'react';
import { mediaItems } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            精彩推荐
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            每日精选热播好剧，让你不错过任何一部值得追的精彩作品
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <MediaCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}

function MediaCard({ item }: { item: typeof mediaItems[0] }) {
  const [imgError, setImgError] = useState(false);

  return (
    <div className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/70 transition-all duration-300 hover:scale-[1.02] cursor-pointer">
      {!imgError && (
        <div className="relative aspect-video overflow-hidden">
          <img
            src={item.image}
            alt={item.title}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            onError={() => setImgError(true)}
          />
          <div className="absolute top-3 left-3">
            <span className="px-2.5 py-1 text-xs font-medium rounded-full bg-primary-500 text-background-50 whitespace-nowrap">
              {item.tag}
            </span>
          </div>
          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center cursor-pointer">
              <i className="ri-play-fill text-2xl text-background-50 ml-0.5"></i>
            </div>
          </div>
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
            <span className="text-xs text-background-50/80">{item.views} 次播放</span>
          </div>
        </div>
      )}
      <div className="p-4">
        <h3 className="text-base font-heading font-bold text-foreground-900 group-hover:text-primary-500 transition-colors">
          {item.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500">{item.subtitle}</p>
      </div>
    </div>
  );
}